import * as React from 'react';
import { useContext } from 'react';
import { PagedContext } from './paged-context';
import { Box } from './ui';

type Props = {
  breakBelow?: number;
  children: Array<React.ReactNode>;
  divider: React.ReactNode;
};

const Divider = ({ breakBelow, children, divider }: Props) => {
  const content: React.ReactNode[] = [];
  const childrenArray = React.Children.toArray(children);
  childrenArray.forEach((element, index) => {
    if (element) {
      content.push(element);

      if (index !== childrenArray.length - 1) {
        if (breakBelow) {
          content.push(
            React.cloneElement(
              <BreakingDivider breakBelow={breakBelow} divider={divider} />,
              {
                key: `divider-${index}`,
              }
            )
          );
        } else {
          content.push(
            React.cloneElement(<>{divider}</>, {
              key: `divider-${index}`,
            })
          );
        }
      }
    } else if (!element && index === childrenArray.length - 1) {
      content.pop();
    }
  });
  if (content.length === 0) return null;
  return <>{content}</>;
};

type BreakingDividerProps = {
  breakBelow: number;
  divider: React.ReactNode;
};

const BreakingDivider = ({ breakBelow, divider }: BreakingDividerProps) => {
  const paged = useContext(PagedContext);
  return (
    <>
      <Box
        sx={{
          display: paged ? 'inline' : 'none',
          [`@media (min-width: ${breakBelow}px)`]: {
            display: 'inline',
          },
        }}
      >
        {divider}
      </Box>
      <Box
        as="br"
        sx={{
          display: paged ? 'none' : 'inline',
          [`@media (min-width: ${breakBelow}px)`]: {
            display: 'none',
          },
        }}
      />
    </>
  );
};

export default Divider;
